var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_vm._l((_vm.menuList),function(item,index){return [(item.path)?_c('el-breadcrumb-item',{key:item.path + index,attrs:{"to":{ path: item.path ? item.path : '' }}},[_vm._v(_vm._s(item.name))]):_c('el-breadcrumb-item',{key:item.name + index},[_vm._v(_vm._s(item.name))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }